<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div class="box">
    </div>
</template>

<script>
    export default {
        components: {},
        name: "formDetail",
        props: {
            tabId:{},
            tabs:{},
            onlyIdsTab:{},
            showType:{}
        },
        data() {return {}},
        watch:{},
        methods: {},
        mounted() {},
    }
</script>

<style>
    .job table th, .job table td {white-space: nowrap}
</style>
